import { useMemo } from 'react';
import { isEmptyObject } from '../../../../../../../core/util/object';

const EMPTY_DETAILS_RESULT_OBJECT = {};

export default (insuranceProfile: any, insuranceDetails: any) => {
  return useMemo(() => {
    if (!isEmptyObject(insuranceProfile) && !isEmptyObject(insuranceDetails)) {
      return insuranceDetails;
    }
    return EMPTY_DETAILS_RESULT_OBJECT;
  }, [insuranceDetails, insuranceProfile]);
};
